<p-dialog header="{{ currentHeader }}" [(visible)]="displayAddressAdd" [modal]="true" [responsive]="true"
  [closable]="false" [style]="{ width: '60vw' }">
  <form (ngSubmit)="addToAddressList()" #addAdddressFrm="ngForm">
    <div class="header">
      <h5>
        Address Information
        <p-inputSwitch name="statusId" class="header-switch" [disabled]="addressTemp.address.isDefault"
          [(ngModel)]="addressTemp.address.statusId" [trueValue]="1" [falseValue]="2">
        </p-inputSwitch>
      </h5>
    </div>
  <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
          <div class="p-d-flex p-jc-between">
            <label>Address Type <span style="color: red">*</span>
              @if(checkedFields?.AddressType?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{checkedFields?.AddressType?.description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <div class="p-field-checkbox p-mb-0" *ngIf="isShowShipping">
              <p-checkbox [(ngModel)]="sameAsBilling" binary="true" inputId="binary"></p-checkbox>
              <label for="binary" class="small">Shipping (Same as billing address)</label>
            </div>
          </div>
          <p-dropdown name="addressTypes" [options]="addressTypes" appendTo="body" optionLabel="name"
            [(ngModel)]="selectedAddressType" required placeholder="Select Address Type"
            (onChange)="getAddrType($event)">
          </p-dropdown>
        </div>
        <div class="p-col-12 p-md-6">
          <label>Address Class <span style="color: red">*</span>
            @if(checkedFields?.AddressClass?.description){
              <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                 pTooltip="{{checkedFields.AddressClass.description}}"
                 tooltipPosition="top">
              </i>
            }
          </label>
          <p-dropdown name="addressClasses" [options]="addressClasses" appendTo="body" optionLabel="name"
            [(ngModel)]="selectedAddressClass" required placeholder="Select Address Class">
          </p-dropdown>
        </div>
      </div>
      <div *ngIf="currentLabels.length; else checkedFieldsBlock">
        <div class="p-field p-formgrid p-grid" *ngIf="currentLabels[0] ? currentLabels[0].ischecked == true : null
          || currentLabels[1] ? currentLabels[1].ischecked == true : null">
          <div class="p-col-12 p-lg-6" *ngIf="currentLabels[0] ? currentLabels[0].ischecked == true : null">
            <label>{{currentLabels[0] ? currentLabels[0].labelname : null}}
              @if(currentLabels[0]?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{currentLabels[0].description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <lion-gm-place-autocomplete [formattedAddress]="addressTemp.address.streetAddress1"
              (onRemoveAddress)="onRemoveAddressLocation($event)" (onAddressChange)="onAddressChanged($event)"
              (onSettingAddrress)="onAddressBlur($event)">
            </lion-gm-place-autocomplete>
            <!-- <input name="streetAddress1"
            [ngStyle]="{'visibility' : showPlaceElm == true ? 'hidden' : 'visible'}"
            pInputText type="text" [(ngModel)]="addressTemp.address.streetAddress1" /> -->
          </div>
          <div class="p-col-12 p-lg-6" *ngIf="currentLabels[1] ? currentLabels[1].ischecked == true : null">
            <label>{{currentLabels[1] ? currentLabels[1].labelname : null}}
              @if(currentLabels[1].description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{currentLabels[1].description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <input name="streetAddress2" pInputText type="text" [(ngModel)]="addressTemp.address.streetAddress2" />
          </div>
        </div>
        <div class="p-field p-formgrid p-grid" *ngIf="currentLabels[2] ? currentLabels[2].ischecked == true : null
          || currentLabels[3] ? currentLabels[3].ischecked == true : null">
          <div class="p-col-12 p-lg-6" *ngIf="currentLabels[4] ? currentLabels[4].ischecked == true : null">
            <label>{{currentLabels[2] ? currentLabels[2].labelname : null}}</label>
            <p-dropdown [options]="countries" name="addcountry" placeholder="Select Country" [filter]="true"
              filterBy="name" [(ngModel)]="selectedAddressCountry" optionLabel="name" appendTo="body"
              (onChange)="loadCountryStates()">
            </p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6" *ngIf="currentLabels[3] ? currentLabels[3].ischecked == true : null">
            <label>{{currentLabels[3] ? currentLabels[3].labelname : null}}
              @if(currentLabels[3]?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{currentLabels[3].description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <p-dropdown [options]="stateList" name="addState" placeholder="Select State" [filter]="true" filterBy="name"
              optionLabel="name" dataKey="id" appendTo="body" [(ngModel)]="selectedAddressState"
              (onChange)="loadCountryCities()">
            </p-dropdown>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid" *ngIf="currentLabels[4] ? currentLabels[4].ischecked == true : null
          || currentLabels[5] ? currentLabels[5].ischecked == true : null
          || currentLabels[6] ? currentLabels[6].ischecked == true : null">
          <div class="p-col-12 p-lg-6" *ngIf="currentLabels[2] ? currentLabels[2].ischecked == true : null">
            <label>{{currentLabels[4] ? currentLabels[4].labelname : null}}
              @if(currentLabels[4]?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{currentLabels[4].description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <p-dropdown [options]="cityList" name="addcity" placeholder="Select City" [filter]="true" filterBy="name"
              [(ngModel)]="selectedAddressCity" optionLabel="name" dataKey="id" appendTo="body">
            </p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6" *ngIf="currentLabels[5] ? currentLabels[5].ischecked == true : null">
            <label>{{currentLabels[5] ? currentLabels[5].labelname : null}}
              @if(currentLabels[5]?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{currentLabels[5].description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <input name="zipcode" pInputText type="text" [(ngModel)]="addressTemp.address.zipCode" />
          </div>
          <div class="p-col-12 p-lg-6" *ngIf="currentLabels[6] ? currentLabels[6].ischecked == true : null">
            <label>{{currentLabels[6] ? currentLabels[6].labelname : null}}.
              @if(currentLabels[6]?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{currentLabels[6].description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <p-dropdown [options]="contactListAttn" [attr.disabled]="contactListAttn.length === 0" name="attnContact"
              placeholder="Select Attn" [filter]="true" filterBy="name" inputId="attnContactId"
              [(ngModel)]="selectedAddressattnContact" optionLabel="contactName" dataKey="id" appendTo="body">
            </p-dropdown>
          </div>
        </div>
      </div>
      <ng-template #checkedFieldsBlock>
        <div class="p-field p-formgrid p-grid" *ngIf="checkedFields.StreetAddress1 || checkedFields.StreetAddress2">
          <div class="p-col-12 p-lg-6" *ngIf="checkedFields.StreetAddress1">
            <label>{{checkedFields.StreetAddress1.labelName}}
              @if(checkedFields?.StreetAddress1?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{checkedFields.StreetAddress1.description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <lion-gm-place-autocomplete [formattedAddress]="addressTemp.address.streetAddress1"
              (onRemoveAddress)="onRemoveAddressLocation($event)" (onAddressChange)="onAddressChanged($event)"
              (onSettingAddrress)="onAddressBlur($event)">
            </lion-gm-place-autocomplete>
            <!-- <input name="streetAddress1"
              [ngStyle]="{'visibility' : showPlaceElm == true ? 'hidden' : 'visible'}"
              pInputText type="text" [(ngModel)]="addressTemp.address.streetAddress1" /> -->
          </div>
          <div class="p-col-12 p-lg-6" *ngIf="checkedFields.StreetAddress2">
            <label>{{checkedFields.StreetAddress2.labelName}}
              @if(checkedFields?.StreetAddress2?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{checkedFields.StreetAddress2.description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <input name="streetAddress2" pInputText type="text" [(ngModel)]="addressTemp.address.streetAddress2" />
          </div>
        </div>
        <div class="p-field p-formgrid p-grid" *ngIf="checkedFields.Country || checkedFields.State">
          <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Country">
            <label>{{checkedFields.Country.labelName}}
              @if(checkedFields?.Country?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{checkedFields.Country.description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <p-dropdown [options]="countries" name="addcountry" placeholder="Select Country" [filter]="true"
              filterBy="name" [(ngModel)]="selectedAddressCountry" optionLabel="name" appendTo="body"
              (onChange)="loadCountryStates()">
            </p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6" *ngIf="checkedFields.State">
            <label>{{checkedFields.State.labelName}}
              @if(checkedFields?.State?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{checkedFields.State.description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <p-dropdown [options]="stateList" name="addState" placeholder="Select State" [filter]="true" filterBy="name"
              optionLabel="name" dataKey="id" appendTo="body" [(ngModel)]="selectedAddressState"
              (onChange)="loadCountryCities()">
            </p-dropdown>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid"
          *ngIf="checkedFields.City || checkedFields.Zip || checkedFields.Attn">
          <div class="p-col-12 p-lg-6" *ngIf="checkedFields.City">
            <label>{{checkedFields.City.labelName}}
              @if(checkedFields?.City?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{checkedFields.City.description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <p-dropdown [options]="cityList" name="addcity" placeholder="Select City" [filter]="true" filterBy="name"
              [(ngModel)]="selectedAddressCity" optionLabel="name" dataKey="id" appendTo="body">
            </p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Zip">
            <label>{{checkedFields.Zip.labelName}}
              @if(checkedFields.Zip?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{checkedFields.Zip.description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <input name="zipcode" pInputText type="text" [(ngModel)]="addressTemp.address.zipCode" />
          </div>
          <div class="p-col-12 p-lg-6 p-mt-2" *ngIf="checkedFields.Attn">
            <label>{{checkedFields.Attn.labelName}}.
              @if(checkedFields.Attn?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{checkedFields.Attn.description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <p-dropdown [options]="contactListAttn" [attr.disabled]="contactListAttn.length === 0" name="attnContact"
              placeholder="Select Attn" [filter]="true" filterBy="name" inputId="attnContactId"
              [(ngModel)]="selectedAddressattnContact" optionLabel="contactName" dataKey="id" appendTo="body">
            </p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6 p-mt-2" *ngIf="(moduleId === accountModuleId || moduleId === leadModuleId) && checkedFields.AddressName">
            <label>Address Name
              @if(checkedFields.AddressName?.description){
                <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                   pTooltip="{{checkedFields.AddressName.description}}"
                   tooltipPosition="top">
                </i>
              }
            </label>
            <input name="addName" pInputText type="text" [(ngModel)]="addressName" />
          </div>
        </div>
      </ng-template>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="deleteAddress(addressTemp)" label="Delete" class="p-button-danger"
      *ngIf="addressHeader == 'Edit Address'"></button>
    <button type="button" pButton (click)="cancelAddAddress()" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton class="p-button-success" label="Save" (click)="addAdddressFrm.ngSubmit.emit()"
      [disabled]="addAdddressFrm.form.invalid">
    </button>
  </p-footer>
</p-dialog>


<app-lion-address-type-modal [display]="displayAddAddrType" [addressTypeList]="addressTypes"
  (onCancel)="cancelAddAddressType($event)" (onSave)="onSaveAddressType($event)">
</app-lion-address-type-modal>

<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
<!--<p-toast position="top-right" [baseZIndex]="10000"></p-toast> -->
